<template>
  <div class="chat-message">
    <!-- Custom message content -->
    <!-- <div v-if="content.custom" class="message-content">
      <div class="image-container" v-if="content.custom?.imageUrl">
        <div
          class="image-display"
          :style="{
            backgroundImage: 'url(' + content.custom?.imageUrl + ')'
          }"
        ></div>
      </div>

      <div v-if="content.custom.text" class="text-content">
        <span class="message-text">{{ content.custom.text }}</span>
      </div>

      <div
        v-if="content.custom.button && content.custom.button.length"
        class="button-container"
      >
        <button
          v-for="(btn, j) in content.custom.button"
          :key="j"
          type="button"
          class="action-button"
          @click="handleButtonClick(btn)"
        >
          <span class="button-text">{{ btn.label }}</span>
        </button>
      </div>
    </div> -->

    <!-- Product message (type 5) -->
    <div class="product-message">
      <div
        @click="handleOpenTab(content.externalLink)"
        :class="['product-container', content.externalLink && 'clickable']"
      >
        <!-- Product image -->
        <div class="product-image-container" v-if="content.imageUrl">
          <img :src="content.imageUrl" class="product-image" alt="Product" />
        </div>

        <!-- Product details -->
        <div class="product-details">
          <div v-for="(p, i) in product" :key="i" class="product-info">
            <p
              :class="[
                'product-text',
                i === 0 ? 'product-title' : 'product-description'
              ]"
            >
              {{ p }}
            </p>
          </div>
          <div class="product-price">
            <span class="price-label">Price:</span>
            <span class="price-value">{{
              content.custom?.price || "N/A"
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    con: {
      required: false,
      type: Object
    }
  },
  created() {
    this.content = this.con;
  },
  computed: {
    product() {
      return this.content.message
        ? this.content.message.split("\n").filter(p => p.trim())
        : [];
    }
  },
  data() {
    return {
      content: {}
    };
  },
  methods: {
    handleOpenTab(url) {
      if (url) window.open(decodeURIComponent(url), "_blank");
    },
    handleButtonClick(btn) {
      // Handle button click logic here
      console.log("Button clicked:", btn);
      // You can emit an event or call a parent method
      this.$emit("button-clicked", btn);
    },
    formatTime(timestamp) {
      if (!timestamp) return "";
      const date = new Date(timestamp);
      return date.toLocaleTimeString("th-TH", {
        hour: "2-digit",
        minute: "2-digit"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.chat-message {
  max-width: 340px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.message-content {
  background: #e3f2fd;
  border-radius: 18px 18px 4px 18px;
  overflow: hidden;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  min-width: 120px;
}

.image-container {
  width: 100%;
  position: relative;
}

.image-display {
  width: 100%;
  height: 160px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #f5f5f5;
}

.text-content {
  padding: 12px 16px;
}

.message-text {
  font-size: 14px;
  line-height: 1.4;
  color: #333;
  word-wrap: break-word;
}

.button-container {
  padding: 8px 16px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.action-button {
  background: transparent;
  border: 1px solid #1976d2;
  border-radius: 20px;
  padding: 8px 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;

  &:hover {
    background: #1976d2;
    color: white;
  }

  &:active {
    transform: scale(0.98);
  }
}

.button-text {
  font-size: 13px;
  font-weight: 500;
  color: #1976d2;
}

.action-button:hover .button-text {
  color: white;
}

.product-message {
  overflow: hidden;
}

.product-container {
  display: flex;
  min-height: 80px;

  &.clickable {
    cursor: pointer;
    transition: background-color 0.2s ease;
  }
}

.product-image-container {
  width: 100px;
  height: 100%;
  flex-shrink: 0;
  overflow: hidden;
}

.product-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.product-details {
  flex: 1;
  padding: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.product-info {
  margin: 0;
}

.product-text {
  margin: 0 0 4px 0;
  word-wrap: break-word;
}

.product-title {
  font-size: 14px;
  color: #333;
  line-height: 1.3;
}

.product-description {
  font-size: 12px;
  color: #666;
  line-height: 1.2;
}

.product-header {
  padding-bottom: 8px;
  margin-bottom: 8px;
}

.price-label {
  font-size: 12px;
  color: #666;
  line-height: 1.2;
  margin-right: 3px;
}

.price-value {
  font-weight: 500;
  color: #ee4d2d;
}

/* Responsive adjustments */
@media (max-width: 480px) {
  .chat-message {
    max-width: calc(100vw - 60px);
  }

  .product-container {
    flex-direction: column;
  }

  .product-image-container {
    width: 100%;
    height: 120px;
  }
}
</style>
